import { Stack } from '@mui/joy';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BomPartNumber } from 'bom/elements';
import { IBomPart } from 'bom/types';
import { TextLine } from 'core/elements';
import { ICustomerQuotePart } from 'quotes/types';
import { Color } from 'theme/enums';

import { AddVariation } from './AddVariation';

interface IProps {
  quotePart: ICustomerQuotePart;
  onPartNumberClick?: (part: IBomPart) => void;
  isPartEditable?: boolean;
}

export const PnbPart = ({ quotePart, onPartNumberClick, isPartEditable = false }: IProps) => {
  const [isAddVariationModalOpen, setIsAddVariationModalOpen] = useState(false);

  const { t } = useTranslation();

  const isAddVariationEnabled = isPartEditable && Boolean(quotePart?.partArr?.wildcard);

  return (
    <>
      <Stack spacing={0}>
        <BomPartNumber
          bomPart={quotePart}
          onPartClick={onPartNumberClick}
          isDeleted={Boolean(quotePart?.deleted && !quotePart?.omitted)}
        />

        {isAddVariationEnabled && (
          <TextLine
            text={t('labelAddVariation')}
            onClick={() => setIsAddVariationModalOpen(true)}
            color={Color.PRIMARY}
            isSubText
          />
        )}
      </Stack>

      {isAddVariationEnabled && (
        <AddVariation
          isOpen={isAddVariationModalOpen}
          onClose={() => setIsAddVariationModalOpen(false)}
          quotePart={quotePart}
        />
      )}
    </>
  );
};
